import React from 'react';

const ArrowRight = ({ width = '24px', className = '' }) => (
    <svg width={width} height={width} className={className} viewBox="0 0 24 24"><path d="M10 17l5-5-5-5v10z" /></svg>
);

export default ArrowRight;
